// extracted by mini-css-extract-plugin
export default {"container":"Postgame_container__WVUcl","stack":"Postgame_stack__7yDQP","row":"Postgame_row__Pr3no","button":"Postgame_button__0FnAe"};